export default __webpack_public_path__ + "static/media/referral.9016d145.svg";